import { useState, useEffect } from "react";
/**
 * Debounces a value by the specified delay.
 * Returns the debounced value which only updates after
 * the caller stops changing it for `delayMs` milliseconds.
 */
export const useDebounce = (value, delayMs = 500) => {
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedValue(value);
        }, delayMs);
        return () => clearTimeout(timer);
    }, [value, delayMs]);
    return debouncedValue;
};
